module.exports = __webpack_public_path__ + "238e5cd9929f01ea5e137cca5d1e0919.woff";